module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/heroMobile@2x.4de184f.png";